@if (enabled()) {
  <section
    class="BrowseByCategory"
    colorScheme="browseByCategory.main"
  >
    <div class="container">
      <div class="BrowseByCategory__heading">
        <h2 i18n="@@browse-by-category.title" class="BrowseByCategory__heading__title">Browse by Category</h2>
      </div>
      <div class="BrowseByCategory__content">
        @if (categories$ | async; as categories) {
          @for (item of categories.data; track item.category_id) {
            <div data-testid="category-item">
              <app-button
                [routerLink]="[SearchRoutePaths.CategoryFull.replace(':category', item.category)]"
                class="BrowseByCategory__content__item"
                colorScheme="browseByCategory.items"
                appearance="elevated"
              >
                @if (display()) {
                  @if (item.image) {
                    <div class="BrowseByCategory__content__item__image">
                      <img [imageSource]="{
                          guid: item.image,
                          transparent: true,
                          type: LegacyImageProcessorTypes.ItemDetailBig,
                        }"
                        [applyWatermark]="false"
                        width="100"
                        height="80"
                        [alt]="item.category"
                        loading="lazy"
                      />
                    </div>
                  } @else {
                    <div class="BrowseByCategory__content__item__image">
                      <img width="100" height="80" [src]="globalData.defaultImage()" alt="" loading="lazy"/>
                    </div>
                  }
                }
                <div class="BrowseByCategory__content__item__container">
                  <h3 class="BrowseByCategory__content__item__title">
                    {{ item.category }}
                  </h3>
                  <p class="BrowseByCategory__content__item__quantity" [style]="styles().subtext">
                    {{ quantityAvailable.replace('__QUANTITY__', item.quantity.toString()) }}
                  </p>
                </div>

              </app-button>
            </div>
          }
        } @else {
          @for (item of [].constructor(+quantity()); track $index) {
            <div>
              <div class="BrowseByCategory__content__item spinner" [style]="styles().category">
                <mat-spinner diameter="25"></mat-spinner>
              </div>
            </div>
          }
        }
        <app-button
          i18n="@@browse-by-category.view-more-link.anchor-text"
          (click)="loadAndOpenCategoryFilters()"
          class="BrowseByCategory__content__item BrowseByCategory__content__item--view-more"
          colorScheme="browseByCategory.items"
          appearance="elevated"
        >View more equipment</app-button>
      </div>
    </div>
  </section>
}